if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.cartDrawer = this.closest('cart-drawer');
      this.noteOpen = this.querySelector('.CartNote__CtaButton');
      this.noteClose = this.querySelector('.CartNote__PopupBack');
      this.notePopup = this.querySelector('.CartNote__Popup');
      this.noteAdd = this.querySelector('.CartNote__PopupSubmit');
      this.noteClear = this.querySelector('.CartNote__Clear');
      this.noteTextarea = this.querySelector('.CartNote__Textarea');
      this.noteMessage = this.querySelector('.CartNote__NoteMessage');
      this.symbolsCount = this.querySelector('.CartNote__SymbolsCount');
      this.maxCharacters = Number(this.noteTextarea.getAttribute('maxlength'));

      this.noteOpen.addEventListener('click', this.open.bind(this))
      this.noteClose.addEventListener('click', this.close.bind(this))
      this.noteAdd.addEventListener('click', this.fetchNote.bind(this))
      this.noteClear.addEventListener('click', this.clearNote.bind(this))
      this.noteTextarea.addEventListener('input', this.charactersRemaining.bind(this))

      this.charactersRemaining();
    }

    open() {
      this.notePopup.setAttribute('aria-hidden', 'false');
    }

    close() {
      this.notePopup.setAttribute('aria-hidden', 'true');
    }

    fetchNote(closePopup = true, clearMessage= false) {
      let noteValue = this.noteTextarea.value;
      let config = fetchConfig('javascript');
      if (clearMessage) {
        noteValue = '';
      }
      config.headers['X-Requested-With'] = 'XMLHttpRequest';

      const body = JSON.stringify({
        attributes: {
          'Gift message': noteValue
        },
        sections: this.cartDrawer.getSectionsToRender().map((section) => section.id),
      });

      config.body = body;

      fetch(`${routes.cart_update_url}`, config)
        .then((response) => response.json())
        .then(response => {
          this.noteMessage.textContent = noteValue;
          if (closePopup) this.close();

          this.updateCta(noteValue);
          if (noteValue) {
            sessionStorage.setItem('cartNote', 'true');
          }
        })

    }

    clearNote() {
      this.noteTextarea.value = '';
      this.charactersRemaining();
      this.fetchNote(false);
    }

    updateCta(noteValue) {
      if (noteValue) {
        this.noteOpen.classList.add('Editable');
      } else {
        this.noteOpen.classList.remove('Editable');
      }
    }

    charactersRemaining() {
      const valueLength = this.noteTextarea.value.length
      const charactersRemaining = this.maxCharacters - valueLength + '';

      this.symbolsCount.textContent = charactersRemaining;
    }

  }

  customElements.define('cart-note', CartNote);
}